import { useAtom } from 'jotai';
import CompoundSlider from 'components/CompoundSlider';
import { useCallback, useEffect, useRef } from 'react';
import useRudderStackTrack from 'hooks/useRudderStackTrack';
import useIsMount from 'utils/useIsMount';
import { atomWithReset } from 'jotai/utils';
import { SliderValueTuple } from 'components/search/v2/Filter/atomUtils';

export default function AtomSlider({ atom }) {
  const [ourAtom, setOurAtom] = useAtom<Record<string, unknown>>(atom);
  const { min, max, label, unit, step, pushable, valueAtom } = ourAtom;
  const [value, setValue] = useAtom<unknown>(valueAtom as any);

  const debounceRef = useRef<ReturnType<typeof setTimeout>>();

  const onChangeCallback = useCallback((newValue) => {
    const newAtom = {
      ...ourAtom,
      valueAtom: atomWithReset<SliderValueTuple>(newValue),
    };
    // @ts-ignore
    setOurAtom(newAtom);
    // @ts-ignore
    setValue(newValue);
    clearTimeout(debounceRef.current);
    // @ts-ignore
    debounceRef.current = setTimeout(() => setOurAtom(newAtom), 250);
  }, []);

  const rudderTrack = useRudderStackTrack();
  const isMount = useIsMount();
  useEffect(() => {
    if (!isMount) {
      rudderTrack('slider_change_search', {
        value,
        label,
      });
    }
  }, [value]);

  return (
    <CompoundSlider
      min={min}
      max={max}
      unit={unit}
      pushable={pushable}
      defaultValue={value}
      label={label}
      step={step}
      onChange={onChangeCallback}
    />
  );
}
